export default __webpack_public_path__ + "static/media/renting-benefit.16791dfe.png";